/**
 * @file 博士会成员tab切换页面
 * @author  rentao(v-rentao@baidu.com)
 */
import React from 'react';
import { Col } from 'antd';
import { NumberTabItem } from './types';

import './style.less'

const NumberTab: React.FC<NumberTabItem> = props => {
    const {
        name,
        text,
    } = props;

    return (
        <Col
            className="num-box"
            span={6}
        >

                <div className="num-left"></div>
                <div className="num-right">
                    <p className="num-top">{name}</p>
                    <p className="num-bot">{text}</p>
                </div>

        </Col>
    )

}
export default NumberTab
